// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__ZyQFo","file":"styles_file__2EynZ"};